import type { FeatureGroup } from '../../../types';
import { PAYMENTS_FEATURE_GROUP } from '../group';

export const PAYMENTS_DASHBOARD_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f07ff',
  name: 'payments_dashboard',
  description: 'The payments dashboard and its widgets',
  product: 'payments',
  parentGuid: PAYMENTS_FEATURE_GROUP.guid,
};
